export default __webpack_public_path__ + "static/media/menu.90255240.svg";